import { render, staticRenderFns } from "./PointDelivery.vue?vue&type=template&id=1dc18f82"
import script from "./PointDelivery.vue?vue&type=script&lang=js"
export * from "./PointDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports